import { RoleId } from '@wix/members-domain-ts';

import { getCurrentMember } from '../members/selectors';
import { refreshCurrentMember, renewViewedMember } from '../members/actions';
import { openNotification, openModalWithCallback } from '../../actions/open-modal';
import { getAppComponent } from '../site/selectors';
import SM_PRIVACY_STATUS from '../../constants/site-member-privacy-status';

export const JOINED_COMMUNITY = 'community/JOINED_COMMUNITY';
export const LEFT_COMMUNITY = 'community/LEFT_COMMUNITY';

const joinedCommunity = (uid) => ({ type: JOINED_COMMUNITY, payload: uid });
const leftCommunity = (uid) => ({ type: LEFT_COMMUNITY, payload: uid });

const changeViewedMemberCommunityStatus = (privacyStatus) => async (dispatch, getState, { request }) => {
  const { uid } = getCurrentMember(getState());
  const isJoining = privacyStatus === SM_PRIVACY_STATUS.PUBLIC;
  const translationKey = isJoining ? 'community.join.success-message' : 'community.leave.success-message';
  await request.put('_api/members/me/privacy-status', { privacyStatus });
  dispatch(isJoining ? joinedCommunity(uid) : leftCommunity(uid));
  dispatch(renewViewedMember());
  dispatch(refreshCurrentMember());
  dispatch(openNotification({ translationKey }));
};

export const addCurrentMemberToCommunity = () => (dispatch) => {
  return dispatch(changeViewedMemberCommunityStatus(SM_PRIVACY_STATUS.PUBLIC));
};

export const removeCurrentMemberFromCommunity = () => (dispatch) => {
  return dispatch(changeViewedMemberCommunityStatus(SM_PRIVACY_STATUS.PRIVATE));
};

const createCommunityAction = (onConfirmAction, roleAction) => () => (dispatch, getState) => {
  const onConfirm = () => dispatch(onConfirmAction());
  const props = { originalAppComponent: getAppComponent(getState()) };
  dispatch(openModalWithCallback(roleAction, onConfirm, props));
};

export const openJoinCommunityModal = createCommunityAction(addCurrentMemberToCommunity, RoleId.JOIN_COMMUNITY);

export const openLeaveCommunityModal = createCommunityAction(removeCurrentMemberFromCommunity, RoleId.LEAVE_COMMUNITY);
